import type UserEducationStats from '@bloom/postgresql/entities/education/user-education-stats.entity';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface UserEducationState {
  user: UserEducationStats;
  isLoading: boolean;
  error: string | null;
  setUser: (user: UserEducationStats) => void;
}

export  const useEducationStore = create<UserEducationState>()(
  devtools((set) => ({
    user: null,
    isLoading: false,
    error: null,
    setUser: (user) => set({ user }),
  }))
);
